export default [
  {
    name: 'European Union',
    code: 'EU',
    countryCodes: [
      'AT', 'BE', 'BG', 'HR', 'CY', 'CZ', 'DK', 'EE', 'FI', 'FR', 'DE', 'GR', 'HU', 'IE', 'IT', 'LV', 'LT', 'LU', 'MT', 'NL', 'PL', 'PT', 'RO', 'SK', 'SI', 'ES', 'SE'
    ]
  }
  // { name: 'North America', code: 'NAFTA', countryCodes: ['US', 'CA', 'MX'] }
]
